function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.36445 0 0 3.36445 0 7.5C0 11.6355 3.36445 15 7.5 15C11.6355 15 15 11.6355 15 7.5C15 3.36445 11.6355 0 7.5 0ZM7.95234 11.0801C7.95234 11.1445 7.90898 11.1879 7.84453 11.1879H7.15547C7.09102 11.1879 7.04766 11.1445 7.04766 11.0801V6.1418C7.04766 6.07734 7.09102 6.03398 7.15547 6.03398H7.84453C7.90898 6.03398 7.95234 6.07734 7.95234 6.1418V11.0801ZM7.97344 4.76484C7.97344 4.8293 7.93008 4.87266 7.86563 4.87266H7.13438C7.06875 4.87266 7.02656 4.8293 7.02656 4.76484V3.97969C7.02656 3.91523 7.06992 3.87188 7.13438 3.87188H7.86563C7.93008 3.87188 7.97344 3.91523 7.97344 3.97969V4.76484Z",
  fill: "#8C8C8C"
});

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Information.fe8d8c34.svg";
export { ForwardRef as ReactComponent };